import { AppRoutesNS } from 'src/app/app-routes.namespace'

// QR codes in the field link to either the current or the legacy route, and
// auth flows can observe the legacy URL before its redirect resolves
export function isScanRedirectUrl(url: string): boolean {
  return (
    Boolean(url) &&
    (url.startsWith(AppRoutesNS.Scan.REDIRECT) ||
      url.startsWith(AppRoutesNS.Scan.LEGACY_REDIRECT))
  )
}
